import * as R from 'ramda'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { combineReducers } from 'redux'
import { handleActions, createAction } from 'redux-actions'

const metaInitial = {
  bidStep: null,
  minValue: null,
  totalSteps: null,
  currency: null,
  bidId: null,
  denied: null,
  errorText: null,
  statusText: null,
  bidSuccess: null,
  redirectLink: null,
  agreement: null
}

const dataInitial = {
  paymentMethod: null,
  userPaymentId: null,
  isAnonymous: false,
  doSubscribe: false,
  bidValue: null,
  giftcardData: {
    'number': '', 
    'pin': '', 
    'useGiftCard': false, 
    'partPay': false
  },
}

const paymentMethodsInitial = {}

const putBidActions = generateActions('lots/single/PUT_BID')
export const getBidActions = generateActions('lots/single/GET_BID_INFO')
export const getBidByIdActions = generateActions('lots/single/GET_BID_BY_ID')
const removeCardActions = generateActions('lots/single/REMOVE_CARD')

export const getBidInfo = createAction(
  API_CONST,
  lotId => ({
    actions: getBidActions,
    url: `lots/${lotId}/bids/new`
  })
)

export const getBidById = createAction(
  API_CONST,
  (lotId, bidId) => ({
    actions: getBidByIdActions,
    url: `lots/${lotId}/bid/${bidId}`
  })
)

export const putBid = createAction(
  API_CONST,
  (lotId, data = {}) => ({
    method: 'post',
    noRedirect: true,
    actions: putBidActions,
    url: `lots/${lotId}/bids/new`,
    params: data
  })
)

export const editBid = createAction(
  API_CONST,
  (lotId, bidId, data = {}) => ({
    method: 'post',
    noRedirect: true,
    actions: putBidActions,
    url: `lots/${lotId}/bid/${bidId}`,
    params: data
  })
)

export const clearBidInfo = createAction('lots/single/CLEAR_BID_INFO')
export const setBidData = createAction('lots/single/SELECT_PAYMENT_METHOD', (field, value) => ({ field, value }))

export const removeUserPayment = createAction(
  API_CONST,
  userPaymentId => ({
    method: 'post',
    actions: removeCardActions,
    url: `auth/info/removeCard`,
    params: { userPaymentId }
  }),
  userPaymentId => ({ userPaymentId })
)

// ------------------------- //

const meta = handleActions({
  [[clearBidInfo]]: () => ({ ...metaInitial }),
  [getBidActions[0]]: () => ({ ...metaInitial }),
  [getBidActions[1]]: (state, { payload }) => ({
    ...state,
    ...R.pick(Object.keys(metaInitial), payload)
  }),
  [getBidActions[2]]: (state, { payload }) => {
    const data = R.pathOr({}, [ 'message', 'response', 'data' ], payload)
    return ({
      ...state,
      denied: data.status === 500 ? data.error : null
    })
  },
  [getBidByIdActions[1]]: (state, { payload }) => ({
    ...state,
    bidId: payload._id,
    statusText: payload.status,
    currency: payload.currency,
    bidSuccess: !!payload.userPaymentId
  }),
  [putBidActions[0]]: state => ({ ...state, errorText: null }),
  [putBidActions[2]]: (state, { payload }) => {
    const data = R.pathOr({}, [ 'message', 'response', 'data' ], payload)
    const redirectLink = data.status === 301 ? data.error : null
    
    return ({ ...state, redirectLink, agreement: data.data || '', errorText: (data.error && data.error.indexOf('http') != 0 ) ? data.error : null })
  }
}, metaInitial)

const paymentMethods = handleActions({
  [clearBidInfo]: () => ({ ...paymentMethodsInitial }),
  [getBidActions[1]]: (state, { payload }) => ({
    ...state,
    ...payload.payments || {}
  }),
  [getBidByIdActions[1]]: (state, { payload }) => ({
    ...state,
    ...payload.payments || {}
  })
}, paymentMethodsInitial)

const data = handleActions({
  [clearBidInfo]: () => ({ ...dataInitial }),
  [setBidData]: (state, { payload }) => ({
    ...state,
    [payload.field]: payload.value
  }),
  [getBidByIdActions[1]]: (state, { payload }) => ({
    ...state,
    bidValue: payload.value,
    isAnonymous: payload.isAnonymous,
    userPaymentId: payload.userPaymentId
  })
}, dataInitial)

export default combineReducers({
  meta,
  data,
  paymentMethods
})



// WEBPACK FOOTER //
// ./src/store/reducers/lots/bid.js